import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import logo from '../../../images/logo.png';
import Image from '../../../components/helpers/Image.jsx';
import { shadowsArr } from './ShadowsConstants.jsx';
import WebFont from 'webfontloader';
import EmailSubscribe from '../../../components/signin/EmailSubscribe.jsx';
import twitterImg from '../../../images/twitter.png';
import "./Shadows.css";

export default class ShadowsContainer extends Component {
  componentDidMount() {
    for (let i = 0; i < shadowsArr.length; i++) {
      WebFont.load({
        google: {
          families: [shadowsArr[i].fontFamily]
        },
      });
    }
  }

  goToTwitter() {
    window.open('https://www.twitter.com/mixfont', '_blank');
  }

  goHome() {
    browserHistory.push('/');
  }

  goToShadowsAbout() {
    browserHistory.push('/shadows/about');
  }

  render () {
    const {
      children
    } = this.props;
    return (
      <div>
        <div className="splash-background">
          <div className="splash-header">
            <div className="splash-header-logo"
              onClick={this.goHome}>
              <Image src={logo} className="splash-header-logo-image" />
              <span className="trendy-text">Trendy CSS Text Shadows by</span> MIXFONT
            </div>
          </div>
        </div>
        {children}
        <div className="splash-footer">
          <div className="splash-sign-in">
            <div className="splash-beta">
              Thanks for visiting! Want more text shadows? Sign up for our mailing list to get the latest updates.
            </div>
            <EmailSubscribe />
          </div>
          <div className="social-media-bar">
            <div className="social-media-twitter" onClick={this.goToTwitter}>
              <img src={twitterImg} alt="Twitter link" className="twitter-image" />
            </div>
          </div>
          <div className="footer-bar">
            <div className="splash-header-logo"
              onClick={this.goHome}>
              <Image src={logo} className="splash-header-logo-image" />
              MIXFONT
            </div>
            <div className="footer-copyright">
              © 2017 Mixfont Inc.
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/shadows/ShadowsContainer.jsx